import { render } from "./DashboardCms.vue?vue&type=template&id=6adb118b&scoped=true"
import script from "./DashboardCms.vue?vue&type=script&lang=js"
export * from "./DashboardCms.vue?vue&type=script&lang=js"

import "./DashboardCms.vue?vue&type=style&index=0&id=6adb118b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adb118b"]])

export default __exports__